var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocLinkIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6673 9.36047C13.6673 9.52601 13.5332 9.66019 13.3676 9.66019H5.29572C5.1302 9.66019 4.99601 9.52601 4.99601 9.36047V3.96552C4.99601 3.8 5.1302 3.6658 5.29572 3.6658H13.3676C13.5332 3.6658 13.6673 3.8 13.6673 3.96552V9.36047ZM13.3676 2.66675H5.29572C4.57846 2.66675 3.99701 3.24819 3.99701 3.96544V5.34091H2.63172C1.91446 5.34091 1.33301 5.92235 1.33301 6.6396V12.0346C1.33301 12.7519 1.91449 13.3334 2.6318 13.3334H3.87048C3.94404 13.3334 4.00368 13.2738 4.00368 13.2002V12.4676C4.00368 12.394 3.94404 12.3344 3.87046 12.3344H2.63172C2.4662 12.3344 2.33201 12.2002 2.33201 12.0346V6.63967C2.33201 6.47415 2.4662 6.33996 2.63172 6.33996H3.99701V9.36055C3.99701 10.0778 4.57846 10.6593 5.29572 10.6593H11.0033V12.0346C11.0033 12.2002 10.8692 12.3344 10.7036 12.3344H5.80268C5.36085 12.3344 5.00268 12.6925 5.00268 13.1344V13.2002C5.00268 13.2738 5.0623 13.3334 5.13588 13.3334H10.7036C11.4209 13.3334 12.0023 12.752 12.0023 12.0347V10.6593H13.3676C14.0849 10.6593 14.6663 10.0778 14.6663 9.36055V3.96552C14.6663 3.24823 14.0849 2.66675 13.3676 2.66675Z",
    fill: "#006564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocLinkIconGreen);
export default __webpack_public_path__ + "static/media/icon-docLinkIconGreen.5240b2222ac799ea8369d784d6c69609.svg";
export { ForwardRef as ReactComponent };